import { Box, Tabs, Tab } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const CustomTabPanel = (props) => {
  const { children, value, index, styles } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      <Box sx={styles ?? { p: 3 }}>{children}</Box>
    </div>
  );
}

export const ContentHeaderTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.primary.main,
    height: "5px"
  },
}));

export const HeaderTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'sx' && prop !== 'customWidth',
})(({ theme, sx }) => {
  const customWidth = sx && typeof sx === 'object' && 'width' in sx
    ? sx.width
    : `${100 / 3}%`;

  return {
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    borderBottom: `5px solid ${alpha(theme.palette.secondary.main, 0.05)}`,
    padding: "1rem",
    width: customWidth,
    maxWidth: `${customWidth} !important`,
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&.Mui-focusVisible": {
      backgroundColor: alpha(theme.palette.secondary.main, 0.3),
    },
    ...(sx && typeof sx === 'object' ? sx : {}),
  };
});
